$( document ).ready(function() {

  $(".top_btn").on("click", function() {
      $('html,body').animate({ scrollTop: 0 }, 'slow');
        return false; 
  });
  $(window).scroll(function() {
      if ($(this).scrollTop() > 75) {
          $('.top_btn').fadeIn();
      } else {
          $('.top_btn').fadeOut();
      }
  }).trigger('scroll');
 

  if ($(window).width() < 768){
    $('.site-footer .grid__item[data-type="newsletter"]').insertAfter('.site-footer .grid__item[data-type="logo_social"]');

    // function readMore(){
    //   $('.read_btn').each(function(){
    //     if ($(this).text() == "Read more") {
    //       $(this).prev().css({"max-height":"250px", "overflow":"hidden","transition":"all ease 0.2s"});
    //     }
    //   });
    // }
    // readMore();
    $('.read_btn').click(function() {
      $(this).toggleClass("active");
      var thi_parent = $(this).parents('.content__box');
      if ($(this).text() == "Read more") {
        thi_parent.find('.html_content .readtTexthide').slideDown();
         // $(this).prev().css({"max-height":"100%", "overflow":"visible","transition":"all ease 0.2s"});
          $(this).text("Read less");
        } else {
        thi_parent.find('.html_content .readtTexthide').slideUp();
        //  $(this).prev().css({"max-height":"250px", "overflow":"hidden","transition":"all ease 0.2s"});
          $(this).text("Read more");
        }
    });
  }
  
  $('.share_icon').click(function(){
      $('.share_inner').slideToggle();
   }); 
   $(document).keydown(function(e) {
	var $scrollable = $(".tool-tip__content");
	var scrollTop = $scrollable.scrollTop();
    if(e.which == 38){
    	$scrollable.scrollTop(scrollTop - 10);
    } else if(e.which == 40) {
    	$scrollable.scrollTop(scrollTop + 10);
    }
   });
  $('.product__thumbs--beside .product__thumb-item').on('click',function(){
    var index = $(this).attr('data-index');
     $('html, body').animate({
        scrollTop: $('.product_stack_img .product-main-slide[data-index="'+index+'"]').offset().top -40
    }, 1000);
  });
  $("#announcement-bar").click(function () {
    $("html, body").animate({
      scrollTop: $(".footer__item-padding.block_newsletter").offset().top
    }, 500) /* 500 milliseconds*/
    
  });


  $('.show_me_btn').click(function(){
      $('.upsell_popup').addClass('active');
      $('html').addClass('js-drawer-open');
   }); 
   $('.popup_overlay,.upsell_close_icon').click(function(){
      $('.upsell_popup').removeClass('active');
      $('html').removeClass('js-drawer-open');
   }); 
   $('.up_variant select').on('change', function() {
    $('option:selected', this).attr('selected',true).siblings().removeAttr('selected');
     var id = $(this).attr('data-id'); 
     var price = $('option:selected', this).attr('data-price');
     var compareprice = $('option:selected', this).attr('data-cprice');
     var selected_varient = $('option:selected', this).val();
     var availabilty = $('option:selected', this).attr('data-available');
     if (availabilty == 'true'){
       $('.up_main_product_inner[data-productid="'+id+'"] .selected_product').prop('disabled', false);
     } else {
       $('.up_main_product_inner[data-productid="'+id+'"] .selected_product').prop('disabled', true);
     }
     $('.up_main_product_inner[data-productid="'+id+'"] .selected_product').val(selected_varient);
     $('.up_main_product_inner[data-productid="'+id+'"] .main_price').html(price);
     $('.up_main_product_inner[data-productid="'+id+'"] .compare_price').html(compareprice);
   }); 
  
  $('.up_variant .selected_product').each(function(){
     $(this).change(function() {
        var numberOfChecked = $('input.selected_product:checkbox:checked').length;
        if(numberOfChecked > 0) {
          $('.add_up_btn').removeClass('disabled');
        }else{
           $('.add_up_btn').addClass('disabled');
        }
      });  
  });  
  
  
  
  $('.add_up_btn').click(function(e){
      e.preventDefault();
      Shopify.queue = [];
    $('.up_variant .selected_product:checked').each(function(){
     var varient_id = $(this).val();
      console.log(varient_id);
      Shopify.queue.push({
        variantId: varient_id,
        quantity: 1
      });
    });
    Shopify.moveAlong = function() {
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      var data = 'id='+ request.variantId + '&quantity='+ request.quantity ;
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: data,
        success: function(res){
          Shopify.moveAlong();
        },
        error: function(){
            if (Shopify.queue.length){
              Shopify.moveAlong();
            } 
        }
      });
    }
    else {
      document.dispatchEvent(new CustomEvent('cart:build'));
      $('.add_up_btn').text('Added to cart');
      $('.upsell_popup').removeClass('active'); 
      $('.cart-link').trigger('click');
    }
  };
  Shopify.moveAlong();
  });

  // $.get("https://ipinfo.io", function (response) {
  //   setTimeout(function() {
  //     console.log(response);
  //     $('.disclosure-list__option[data-value="'+response.country+'"]').trigger('click').change();
  //     $('.disclosure-list__option[data-value="'+response.country+'"]').parent().addClass('disclosure-list__item--current').siblings().removeClass('disclosure-list__item--current');
  //     Cookies.set('location',response.country);
  //     Cookies.set('localization',response.country);
  //     var cart_currency = $('li.disclosure-list__item.disclosure-list__item--current .disclosure-list__option').attr('data-currency');
  //     Cookies.set('cart_currency',cart_currency);
  //   }, 2000);
    
  // }, "jsonp");


 $(".DstLogoListSlider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay:true,
    dots: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none"><path d="M30.0001 36.8777L18.0001 24.8777L30.0001 12.8777" stroke="#312524" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none"><path d="M18 36.8777L30 24.8777L18 12.8777" stroke="#312524" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',

    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 4,
          centerMode: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          centerMode: false,
          arrows: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 1,
        },
      },
    ],
  });
  

 $(".DstColListSlider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    autoplay:false,
    dots: false,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none"><path d="M30.0001 36.8777L18.0001 24.8777L30.0001 12.8777" stroke="#312524" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none"><path d="M18 36.8777L30 24.8777L18 12.8777" stroke="#312524" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          centerMode: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          centerMode: false,
          arrows: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 1,
        },
      },
    ],
  });

  
 
});  

// ==========swiper-js==========



/*07-06-2023*/

// ==========product-metafield-color-js==========
$( document ).ready(function() {
  $(".list_colors .list_link").hover(function(){
    var product_tag1 = $(this).attr("product-tag");
      $(".product_color .product-tag-contain").text(product_tag1);
  });
  $(".list_colors .list_link").mouseleave(function(){
    var product_tag2 = $(".product-active .list_link").attr("product-tag");
     $(".product-tag-contain").text(product_tag2);
    cpm
  });
});  
// ==========product-metafield-color-js==========